<script lang="ts">
    import CircleHelp from "@lucide/svelte/icons/circle-help";
    import * as Tooltip from "../../lib/components/ui/tooltip/index.js";

    const {
        label,
        hint,
    }: {
        label: string;
        hint?: string;
    } = $props();
</script>

{#if hint}
    <span class="inline-flex items-center gap-1">
        {label}
        <Tooltip.Root>
            <Tooltip.Trigger>
                {#snippet child({ props })}
                    <span {...props} class="text-muted-foreground hover:text-foreground inline-flex cursor-help">
                        <CircleHelp class="size-3.5" />
                    </span>
                {/snippet}
            </Tooltip.Trigger>
            <Tooltip.Content side="bottom" class="max-w-64 text-center">{hint}</Tooltip.Content>
        </Tooltip.Root>
    </span>
{:else}
    {label}
{/if}
